import { Injectable } from '@angular/core';

import { ApiService } from '../api/api.service';
import { SavedReportView, SavedReportViewFilters } from '../../models/saved-report-view';
import { ListResponse } from '../../models/list-response';


@Injectable({
  providedIn: 'root'
})
export class SavedReportViewService {
  constructor(
    private apiService: ApiService
  ) {}

  getSavedReportViews(pageNumber?: number,
                      pageSize?: number,
                      filters?: SavedReportViewFilters): Promise<ListResponse<SavedReportView>> {
    return this.apiService.getCollection<SavedReportView, SavedReportViewFilters>(
      'saved-report-views/',
      pageNumber,
      pageSize,
      filters
    );
  }

  getSavedReportView(id: number): Promise<SavedReportView> {
    return this.apiService.getItem<SavedReportView>(
      'saved-report-views/',
      id
    );
  }

  addSavedReportView(srv: SavedReportView): Promise<SavedReportView> {
    return this.apiService.postToAPI<SavedReportView>(
      'saved-report-views/',
      {
        report_type: srv.report_type,
        name: srv.name,
        columns: srv.columns,
        filters: srv.filters,
      }
    );
  }

  updateSavedReportViewColumnsAndFilters(srv: SavedReportView,
                                         newColumns: string[],
                                         newFilters: any): Promise<SavedReportView> {
    return this.apiService.patchToAPI<SavedReportView>(
      srv.url,
      {
        columns: newColumns,
        filters: newFilters,
      }
    );
  }

  updateSavedReportViewName(srv: SavedReportView, newName: string): Promise<SavedReportView> {
    return this.apiService.patchToAPI<SavedReportView>(
      srv.url,
      {
        name: newName,
      }
    );
  }

  deleteSavedReportView(srv: SavedReportView): Promise<void> {
    return this.apiService.deleteFromAPI<any>(
      srv.url
    ).then();
  }
}
